import { render } from "./AdminBatchEmail.vue?vue&type=template&id=1cd90a81&scoped=true"
import script from "./AdminBatchEmail.vue?vue&type=script&lang=js"
export * from "./AdminBatchEmail.vue?vue&type=script&lang=js"

import "./AdminBatchEmail.vue?vue&type=style&index=0&id=1cd90a81&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd90a81"]])

export default __exports__